<template>
  <div
    id="upload-document"
    class="md:tw-w-96 tw-w-11/12 tw-flex tw-flex-col tw-items-center tw-pb-8"
  >
    <OnboardingHeader headerText="Upload document" />
    <OnboardingSubHeader
      subHeaderText="Upload any Legal document that proves you are a  structured body."
    />
    <form @submit.prevent="uploadLegalDocument">
      <div class="content tw-mt-12">
        <label for="cac document" class="tw-text-lg tw-text-gray">
          CAC 2
        </label>
        <DragNDrop
          class="tw-mt-2"
          accept="image/png,image/jpeg,image/jpg,.pdf"
          :currentValue="legalDocument.documents[0].url"
          :startUpload="uploadLegalDoc"
          @re-upload="uploadLegalDoc = false"
          @upload-complete="setCac2"
          @upload-error="legalUploadError"
        >
          <p
            class="tw-text-sm tw-text-secondary tw-w-full tw-text-center tw-mb-2"
          >
            Drag and drop file
          </p>
        </DragNDrop>

        <label for="Incorporation Document" class="tw-text-lg tw-text-gray">
          Incorporation Document
        </label>
        <DragNDrop
          class="tw-mt-2"
          accept="image/png,image/jpeg,image/jpg,.pdf"
          :currentValue="legalDocument.documents[1].url"
          :startUpload="uploadLegalDoc"
          @re-upload="uploadLegalDoc = false"
          @upload-complete="setIncorpotationDocument"
          @upload-error="legalUploadError"
        >
          <p
            class="tw-text-sm tw-text-secondary tw-w-full tw-text-center tw-mb-2"
          >
            Drag and drop file
          </p>
        </DragNDrop>

        <label for="Memorandum of Association" class="tw-text-lg tw-text-gray">
          Memorandum of Association
        </label>
        <DragNDrop
          class="tw-mt-2"
          accept="image/png,image/jpeg,image/jpg,.pdf"
          :currentValue="legalDocument.documents[2].url"
          :startUpload="uploadLegalDoc"
          @re-upload="uploadLegalDoc = false"
          @upload-complete="setMemoOfAsso"
          @upload-error="legalUploadError"
        >
          <p
            class="tw-text-sm tw-text-secondary tw-w-full tw-text-center tw-mb-2"
          >
            Drag and drop file
          </p>
        </DragNDrop>
      </div>
      <div class="btn-container tw-flex">
        <button
          type="button"
          class="tw-border tw-rounded tw-text-sm tw-text-secondary-dark tw-bg-gray-light tw-px-2 tw-py-4"
          @click="$router.push('/onboarding/create-pin')"
          :disabled="legalLoading"
        >
          Skip this step
        </button>
        <button
          class="tw-bg-primary tw-rounded tw-text-sm tw-text-white tw-px-2 tw-py-4"
          :disabled="legalLoading"
        >
          <span v-if="!legalLoading">Submit</span>
          <img
            v-show="legalLoading"
            class="tw-m-auto"
            src="@/assets/img/spinner.svg"
            alt="animated spinner"
          />
        </button>
      </div>
    </form>
  </div>
</template>

<script>
  import { mapActions } from "vuex";
  import OnboardingHeader from "@/components/onboarding/OnboardingHeader.vue";
  import OnboardingSubHeader from "@/components/onboarding/OnboardingSubHeader.vue";
  import DragNDrop from "@/components/general/DragNDrop";

  export default {
    name: "UploadDocument",

    components: { DragNDrop, OnboardingHeader, OnboardingSubHeader },

    data() {
      return {
        legalLoading: false,
        uploadLegalDoc: false,
        legalDocument: {
          documents: [
            {
              name: "CAC2",
              url: "",
              type: "legal",
            },
            {
              name: "Incorporation Document",
              url: "",
              type: "legal",
            },
            {
              name: "Memorandum of Association",
              url: "",
              type: "legal",
            },
          ],
        },
      };
    },

    methods: {
      ...mapActions("organisationModule", ["submitKycDocument"]),
      ...mapActions(["showToast"]),

      async submitLegalDocument() {
        const cac = this.legalDocument.documents[0].url;
        const incorporation = this.legalDocument.documents[1].url;
        const asso = this.legalDocument.documents[2].url;
        if (!cac || !incorporation || !asso) return;
        const response = await this.submitKycDocument(this.legalDocument);
        if (response) {
          const { message } = response.data;
          this.showToast({
            description: message,
            display: true,
            type: "success",
          });
          this.$router.push({ name: "CreatePin" });
        }
        this.legalLoading = false;
        this.uploadLegalDoc = false;
      },

      setCac2(url) {
        this.legalDocument.documents[0].url = url;
        this.submitLegalDocument();
      },

      setIncorpotationDocument(url) {
        this.legalDocument.documents[1].url = url;
        this.submitLegalDocument();
      },

      setMemoOfAsso(url) {
        this.legalDocument.documents[2].url = url;
        this.submitLegalDocument();
      },

      legalUploadError() {
        this.legalLoading = false;
        this.uploadLegalDoc = false;
      },

      uploadLegalDocument() {
        this.legalLoading = true;
        this.uploadLegalDoc = true;
      },
    },
  };
</script>

<style lang="scss" scoped>
  #upload-document {
    .btn-container {
      display: grid;
      grid-template-columns: 0.7fr 1fr;
      column-gap: 1rem;
    }
  }
</style>
